/* istanbul ignore file */
export * from './TaxHint';
